<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'odcMaterialCode' + _uid"
        :name="'odcMaterialCode' + _uid"
        :select2-options="odcMaterialCodeOptions"
        v-model="item.odcMaterialCode"
        ref="odcMaterialCode"
        data-msg-required="กรุณาเลือกสินค้า"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        type="number"
        class="form-control required text-right"
        min="0"
        placeholder="จำนวน"
        :id="'odcQuantity' + _uid"
        :name="'odcQuantity' + _uid"
        v-model="item.odcQuantity"
        data-msg-required="กรุณากรอกจำนวน"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        type="number"
        class="form-control required text-right"
        min="0"
        placeholder="ราคา"
        :id="'odcPrice' + _uid"
        :name="'odcPrice' + _uid"
        v-model="item.odcPrice"
        data-msg-required="กรุณากรอกราคา"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        type="number"
        class="form-control required text-right"
        min="0"
        :id="'odcTotal' + _uid"
        :name="'odcTotal' + _uid"
        v-model="totalCal"
        readonly
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'odcBudgetId' + _uid"
        :name="'odcBudgetId' + _uid"
        :select2-options="odcBudgetIdOptions"
        v-model="item.odcBudgetId"
        ref="odcBudgetId"
        data-msg-required="กรุณาเลือกงบประมาณ"
      ></select2>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'odcQuotaId' + _uid"
        :name="'odcQuotaId' + _uid"
        :select2-options="odcQuotaIdOptions"
        v-model="item.odcQuotaId"
        ref="odcQuotaId"
        data-msg-required="กรุณาเลือกโควต้า"
      ></select2>
    </td>
    <td class="form-group">
      <center>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveItemClick"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>

<script>
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    var self = this;

    return {
      odcMaterialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcBudgetIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/BudgetBrand/Select2BudgetQuery",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcQuotaIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  computed: {
    totalCal() {
      return (this.item.odcTotal = this.item.odcQuantity * this.item.odcPrice);
    }
  },
  methods: {
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    }
  },
  mounted() {
    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Order/OrderItemRow.vue